import moment from 'moment';

import payoutTransactionService from 'src/api/payoutTransaction';

function PerformancePayoutsTransactionsCtrl($scope, $q, $stateParams, organizationService, managementUserOrganizationMemberService, venueService, permissionService, alertService, sdkUtils, $timeout, dateUtilsService) { //eslint-disable-line
  // const currentUserOrganization = organizationService.getCurrentOrganization();

  $scope.getPayoutTransactions = function() {
    $scope.payoutTransactionsLoading = true;

    return $q.resolve(payoutTransactionService.listByVenueIdAndPayoutId($stateParams.venueId, $stateParams.payoutId))
      .then(response => {
        $scope.payoutTransactions = response.data.map(payout => {
          payout.availableOn = moment.utc(payout.availableOn);

          if (payout.admissionGroup) {
            payout.admissionGroup.date = moment.utc(payout.admissionGroup.date);
          }

          return payout;
        });
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)))
      .finally(() => {
        $scope.payoutTransactionsLoading = false;
      });
  };

  $scope.getPayoutTransactions();
}

PerformancePayoutsTransactionsCtrl.$inject = [
  '$scope',
  '$q',
  '$stateParams',
  'organizationService',
  'managementUserOrganizationMemberService',
  'jsSdk.venue',
  'permissionService',
  'alertService',
  'jsSdk.utils',
  '$timeout',
  'dateUtilsService'
];

export default PerformancePayoutsTransactionsCtrl;



// WEBPACK FOOTER //
// ./src/components/performancePayoutTransactions/performancePayoutTransactionsCtrl.js